mutation CreatePricelist($pricelist: PricelistInput!) {
    createPricelist(pricelist: $pricelist) {
        id
        brandID
        name(language: "en") { language text }
        currency
        countries
        valid { from to }
    }
}
